export const selectFilterOption = (input, { children }) =>
	children.toLowerCase().includes(input.toLowerCase());
